import { Component } from "@angular/core";
import { NavController, ModalController, ViewController, AlertController, App, NavParams } from "ionic-angular";
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser';

import { DataProvider } from '../../providers/data/data';
import { CardProvider } from '../../providers/data/data';

import { ProcessPage } from '../process/process';
import { URLS } from '../../environments/environment';

@Component({
  selector: "page-member",
  templateUrl: "member.html"
})
export class MemberPage {
  private url = '';

  constructor(
    public app: App,
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    private alertCtrl: AlertController,
    public viewCtrl: ViewController,
    private data: DataProvider,
    private card: CardProvider,
    private navParams: NavParams,
    private inAppBrowser: InAppBrowser,
  ) {
    this.card.programs = [];    
    this.data.currentTabName = '';
  }

  public ionViewDidEnter(): void {
    document.getElementById('mainHeader').style.display = 'block';
    document.getElementById('backmenu').style.display = 'block';   
    document.getElementById('backFrom').innerText = '';
    // document.getElementById('headLogo').style.display = 'block';
    document.getElementById('headTitle').style.display = 'block';
    document.getElementById('headTitle').style.marginTop = '-35px';
    // document.title = '各種お手続き'; 
    this.url = this.navParams.get('url');
    if(this.data.paymentType == 'basic') {
      this.data.currentTabName = '体験・プログラム予約';
    } else {
      this.data.currentTabName = 'ご契約変更';
    }
    /*let result = JSON.parse(localStorage.getItem('shopServices'));    
    for(let j = 0;j < result.length;j++) {
      if(result[j].id.toString().substring(0,1) == 's') {
        this.card.programs.push({id: parseInt(result[j].id.toString().substring(1,2)) + 6, name: result[j].serviceName, type: result[j].id});
      }
    }*/
  }

  showProcess(id: any) {
    if(id == 1) {      
      if(URLS.TRIAL_URL.indexOf('https') > -1) {
        // this.data.currentTabName = 'EMS体験予約';
        this.openUrl(URLS.TRIAL_URL);
        // this.navCtrl.push(ProcessPage, { url: URLS.TRIAL_URL, type: 'web' });
      } else {
        // this.openUrl(URLS.TRIAL_URL);
        this.navCtrl.push(ProcessPage, { url: URLS.TRIAL_URL, type: 'web' });
      }
      // this.navCtrl.push(ProcessPage, { url: 'https://reserve.joyfit.jp/ems_trial/#/index', type: 'web' });
    } else if(id == 2) {      
      if(URLS.SEC_URL.indexOf('https') > -1) {
        // this.data.currentTabName = 'ﾊﾟｰｿﾅﾙﾄﾚｰﾅｰ予約';
        this.openUrl(URLS.SEC_URL + '?id=' + this.data.id + '&time=' + this.data.time + '&hash=' + this.data.hash + '&color=' + this.data.sign.substring(0,1));
        // this.navCtrl.push(ProcessPage, { url: URLS.SEC_URL + '?id=' + this.data.id + '&time=' + this.data.time + '&hash=' + this.data.hash + '&color=' + this.data.sign.substring(0,1), type: 'web' });
      } else {
        // this.openUrl(URLS.SEC_URL + '?id=' + this.data.id + '&time=' + this.data.time + '&hash=' + this.data.hash + '&color=' + this.data.sign.substring(0,1));
        this.navCtrl.push(ProcessPage, { url: URLS.SEC_URL + '?id=' + this.data.id + '&time=' + this.data.time + '&hash=' + this.data.hash + '&color=' + this.data.sign.substring(0,1), type: 'web' });
      }
      // this.openUrl('http://reserve.joyfit.townsystem.co.jp/ptrainer.town/other.jsp?id=' + this.data.id + '&time=' + this.data.time + '&hash=' + this.data.hash);
      // this.navCtrl.push(ProcessPage, { url: 'http://reserve.joyfit.townsystem.co.jp/ptrainer.town/other.jsp?id=' + this.data.id + '&time=' + this.data.time + '&hash=' + this.data.hash, type: 'web' });
    } else if(id == 3) {      
      if(URLS.THIRD_URL.indexOf('https') > -1) {
        // this.data.currentTabName = 'ヨガレッスン予約';
        this.openUrl(URLS.THIRD_URL + '?id=' + this.data.id + '&time=' + this.data.time + '&hash=' + this.data.hash + '&type=green');
        // this.navCtrl.push(ProcessPage, { url: URLS.THIRD_URL + '?id=' + this.data.id + '&time=' + this.data.time + '&hash=' + this.data.hash + '&type=green', type: 'web' });
      } else {
        // this.openUrl(URLS.THIRD_URL + '?id=' + this.data.id + '&time=' + this.data.time + '&hash=' + this.data.hash + '&type=green');
        this.navCtrl.push(ProcessPage, { url: URLS.THIRD_URL + '?id=' + this.data.id + '&time=' + this.data.time + '&hash=' + this.data.hash + '&type=green', type: 'web' });
      }
      // this.navCtrl.push(ProcessPage, { url: 'https://reserve.joyfit.jp/ems_trial/#/index', type: 'web' });
    } else if(id == 4) {      
      if(URLS.FOUR_URL.indexOf('https') > -1) {
        // this.data.currentTabName = 'EMS会員予約';
        this.openUrl(URLS.FOUR_URL + '?id=' + this.data.id + '&time=' + this.data.time + '&hash=' + this.data.hash);
        // this.navCtrl.push(ProcessPage, { url: URLS.FOUR_URL + '?id=' + this.data.id + '&time=' + this.data.time + '&hash=' + this.data.hash, type: 'web' });
      } else {
        // this.openUrl(URLS.FOUR_URL + '?id=' + this.data.id + '&time=' + this.data.time + '&hash=' + this.data.hash);
        this.navCtrl.push(ProcessPage, { url: URLS.FOUR_URL + '?id=' + this.data.id + '&time=' + this.data.time + '&hash=' + this.data.hash, type: 'web' });
      }
      // this.navCtrl.push(ProcessPage, { url: 'https://reserve.joyfit.jp/ems_trial/#/index', type: 'web' });
    } else if(id == 5) {      
      if(URLS.FIVE_ONE_URL.indexOf('https') > -1) {
        // this.data.currentTabName = 'いっしょにジョイ';
        this.openUrl(URLS.FIVE_ONE_URL + this.data.sign.substring(0,1) + URLS.FIVE_TWO_URL + '?id=' + this.data.id + '&time=' + this.data.time + '&hash=' + this.data.hash);
        // this.navCtrl.push(ProcessPage, { url: URLS.FIVE_ONE_URL + this.data.sign.substring(0,1) + URLS.FIVE_TWO_URL + '?id=' + this.data.id + '&time=' + this.data.time + '&hash=' + this.data.hash, type: 'web' });
      } else {
        // this.openUrl(URLS.FIVE_ONE_URL + this.data.sign.substring(0,1) + URLS.FIVE_TWO_URL + '?id=' + this.data.id + '&time=' + this.data.time + '&hash=' + this.data.hash);
        this.navCtrl.push(ProcessPage, { url: URLS.FIVE_ONE_URL + this.data.sign.substring(0,1) + URLS.FIVE_TWO_URL + '?id=' + this.data.id + '&time=' + this.data.time + '&hash=' + this.data.hash, type: 'web' });
      }
      // this.openUrl('http://entry.joyfit.townsystem.co.jp/companion.r.town/other.jsp?id=' + this.data.id + '&time=' + this.data.time + '&hash=' + this.data.hash);
      // this.navCtrl.push(ProcessPage, { url: 'http://entry.joyfit.townsystem.co.jp/companion.r.town/other.jsp?id=' + this.data.id + '&time=' + this.data.time + '&hash=' + this.data.hash, type: 'web' });
    } else if(id == 6) {
      if(URLS.SIX_URL.indexOf('https') > -1) {
        // this.data.currentTabName = 'クレジットカード変更';
        this.openUrl(URLS.SIX_URL + '?id=' + this.data.id + '&time=' + this.data.time + '&hash=' + this.data.hash);
        // this.navCtrl.push(ProcessPage, { url: URLS.SIX_URL + '?id=' + this.data.id + '&time=' + this.data.time + '&hash=' + this.data.hash, type: 'web' });
      } else {
        // this.openUrl(URLS.SIX_URL + '?id=' + this.data.id + '&time=' + this.data.time + '&hash=' + this.data.hash);
        this.navCtrl.push(ProcessPage, { url: URLS.SIX_URL + '?id=' + this.data.id + '&time=' + this.data.time + '&hash=' + this.data.hash, type: 'web' });
      }
      // this.openUrl('http://entry.joyfit.townsystem.co.jp/companion.r.town/other.jsp?id=' + this.data.id + '&time=' + this.data.time + '&hash=' + this.data.hash);
      // this.navCtrl.push(ProcessPage, { url: 'http://entry.joyfit.townsystem.co.jp/companion.r.town/other.jsp?id=' + this.data.id + '&time=' + this.data.time + '&hash=' + this.data.hash, type: 'web' });
    } else if(id == 7) {

    } else if(id == 8) {
      if(URLS.THIRD_URL.indexOf('https') > -1) {
        // this.data.currentTabName = 'ヨガレッスン予約';
        this.openUrl(URLS.THIRD_URL + '?id=' + this.data.id + '&time=' + this.data.time + '&hash=' + this.data.hash + '&type=mash');
        // this.navCtrl.push(ProcessPage, { url: URLS.THIRD_URL + '?id=' + this.data.id + '&time=' + this.data.time + '&hash=' + this.data.hash + '&type=mash', type: 'web' });
      } else {
        // this.openUrl(URLS.THIRD_URL + '?id=' + this.data.id + '&time=' + this.data.time + '&hash=' + this.data.hash + '&type=mash');
        this.navCtrl.push(ProcessPage, { url: URLS.THIRD_URL + '?id=' + this.data.id + '&time=' + this.data.time + '&hash=' + this.data.hash + '&type=mash', type: 'web' });
      }
      // this.navCtrl.push(ProcessPage, { url: 'https://reserve.joyfit.jp/ems_trial/#/index', type: 'web' });
    } else if (id == 9) {
      if(URLS.SEVEN_URL.indexOf('https') > -1) {
        this.openUrl(URLS.SEVEN_URL + '?id=' + this.data.id + '&time=' + this.data.time + '&hash=' + this.data.hash + '&goodwill=JF&type=1');
      } else {
        // this.navCtrl.push(ProcessPage, { url: URLS.SEVEN_URL + '?id=' + this.data.id + '&time=' + this.data.time + '&hash=' + this.data.hash + '&goodwill=JF&type=1', type: 'web' });
        this.openUrl(URLS.SEVEN_URL + '?id=' + this.data.id + '&time=' + this.data.time + '&hash=' + this.data.hash + '&goodwill=JF&type=1');
      }
    } else if (id == 10) {
      if(URLS.SEVEN_URL.indexOf('https') > -1) {
        this.openUrl(URLS.SEVEN_URL + '?id=' + this.data.id + '&time=' + this.data.time + '&hash=' + this.data.hash + '&goodwill=JF&type=2');
      } else {
        // this.navCtrl.push(ProcessPage, { url: URLS.SEVEN_URL + '?id=' + this.data.id + '&time=' + this.data.time + '&hash=' + this.data.hash + '&goodwill=JF&type=2', type: 'web' });
        this.openUrl(URLS.SEVEN_URL + '?id=' + this.data.id + '&time=' + this.data.time + '&hash=' + this.data.hash + '&goodwill=JF&type=2');
      }
    }
  }

  showAlert(err) {
    let alert = this.alertCtrl.create({
      title: "Finish!",
      subTitle: err,
      buttons: [
        {
          text: 'Ok',
          role: 'finish',
          handler: () => {
            this.viewCtrl.dismiss(null);
          }
        }
      ]
    });
    alert.present();
  }

  openUrl(url: any) {
    const options: InAppBrowserOptions = {
      location: 'no',
      clearcache: 'yes',
      clearsessioncache: 'yes',
      hardwareback: 'no',
      enableViewPortScale: 'yes',
      presentationstyle: 'pagesheet',
    };
    // 正常終了時の遷移先をiPad入会サーバサイドの適当なURLにする
    const browser = this.inAppBrowser.create(
      url,
      '_system',
      options
    );
  }

  back() {
    //this.nav.popToRoot();
    this.viewCtrl.dismiss(null);
  }
}



// WEBPACK FOOTER //
// ./src/pages/member/member.ts